import AccessControlListTab from './AccessControlListTab';
import ChangeOwnerDialog from './ChangeOwnerDialog';
import ManagersTab from './ManagersTab';
import ManagersView from './ManagersView';

export default {
  AccessControlListTab,
  ChangeOwnerDialog,
  ManagersTab,
  ManagersView,
};
